//@ts-ignore
import React, { useState, useEffect } from 'react'
import { saveAndEditClient, getClient } from './ClientServices'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import UserTable from './UserTable';
import { Grid, Theme, createStyles, WithStyles, withStyles } from '@material-ui/core';
import UserHeader from './UserHeader';

const styles = (theme: Theme) => createStyles({
    headerAction: {
        margin: '36px 2px 30px',
        '& a': {
            '&::after':{
                content: '" "',
                fontWeight: 600,
                fontSize: 14,
                color: 'rgb(29 125 234)',
                border: 'solid 2px',
                paddingBottom: 2,
                textDecoration: 'none'
            }
        }
    }
});

interface ClientComponentProps extends WithStyles<typeof styles> {
    classes: any,
    userData: any,
}

const createClient = () => {
    //@TODO need to create seperate component
    const [name, setName] = useState('')
    const [address, setAddress] = useState('')
    const [resMsg, setResMsg] = useState('')
    const [clients, setClients] = useState([])
    const [editClient, setEditClient] = useState(null)
    const [editClientIndex, setEditClientIndex] = useState(-1)
    return(<>
       <div>
                    
                    <div><p>{resMsg}</p></div>
                    <h2>{editClient ? 'Edit' : 'Create'} Client </h2>
                    <div>
                        <input type="text" onChange={(e) => { setName(e.target.value) }} value={name} placeholder="Enter Name" />
                    </div>
                    <div>
                        <input type="text" onChange={(e) => { setAddress(e.target.value) }} value={address} placeholder="Enter Address" />
                    </div>

                    <button
                        style={{marginLeft: '10px'}}
                        onClick={(e) => {
                            e.preventDefault();
                            let body = {
                                name,
                                address,
                                "subjects": [
                                    "mathematics",
                                    "logical reasoning",
                                    "biology",
                                    "physics",
                                    "chemistry",
                                    "english",
                                    "social science",
                                    "mat"
                                ],
                                "courses": [],
                                "orgCenters": [],
                                "updatedAt": new Date(),
                                "createdAt": new Date(),
                            }
                            if (editClient) {
                                delete editClient['name']
                                delete editClient['address']
                                editClient.name = name
                                editClient.address = address
                                editClient.updatedAt = new Date()
                                body = { ...editClient }
                            }
                            saveAndEditClient(body, editClient ? editClient._id : null).
                                then((res: any) => {
                                    setName('')
                                    setAddress('')
                                    setEditClient(null)
                                    setEditClientIndex(-1)
                                    if (editClient) {
                                        clients[editClientIndex] = res.responseObject
                                        setClients([...clients])
                                    } else {
                                        setClients([...clients, res.responseObject])
                                    }
                                }).catch((error) => {

                                })
                        }}
                        disabled={name == '' || address == ''}
                    >
                        {editClient ? 'Edit' : 'Create'}
                        
                    </button>
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            setName('')
                            setAddress('')
                            setEditClient(null)
                        }}
                    >
                        Clear
                </button>
                </div>
    </>);
}

const ClientComponent = (props: ClientComponentProps) => {
    const {
        classes
    } = props;
  
    const [setClients] = useState([])

    useEffect(() => {
        getClient('')
            .then((res: any) => {
                const clients = res.responseObject;
                if (clients.length > 0) {
                    // clients.pop()
                }
                setClients(res.responseObject)
            })
    }, [])

    if ('rahul.khanna@edfora.com' === props.userData.authenticatedUser.email) {
        return (
             <>
                <UserHeader />
                <Grid container justify="flex-start" alignItems="center">
                    <Grid item>
                        <Grid className={classes.headerAction}>
                        <Link to="/client">Clients</Link>
                        &nbsp; &nbsp;
                        <Link to="/user" >Users</Link>
                        &nbsp; &nbsp;
                        <Link to="/role" >Roles</Link>

                        {/* <Link to="/user-list" >User List</Link>  for future implementation*/}
                        </Grid>
                    </Grid>                    
                </Grid>
                
                <Grid container>
                    <UserTable />
                </Grid>
                    {/* <table> //Just commented @FrontEnd Dev need to integrate it in a common component
                        <tr>
                            <td>S.no</td>
                            <td>Name</td>
                            <td>Address</td>
                            <td>Action</td>
                        </tr>
                        {clients.map((client: any, index: number) => {
                            return <tr>
                                <td>{index + 1}</td>
                                <td>{client.name && client.name}</td>
                                <td>{client.address && client.address}</td>
                                <td><button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setEditClient(client)
                                        setName(client.name)
                                        setAddress(client.address)
                                        setEditClientIndex(index)
                                    }}
                                >
                                    Edit
                            </button></td>
                            </tr>
                        })}
                    </table> */}
            </>
        )
    } else {
        return <h1> Not permitted </h1>
    }
}


const mapStateToProps = (state: any) => ({
    userData: state.loginData.userData
})


export default connect(mapStateToProps)(withStyles(styles)(ClientComponent));